import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { INotificationService } from '../../interfaces/INotificationService';
import { AppNotification, AppNotificationTypes } from '../../models/other/app-notification.model';
import { BusinessEvent } from '../../models/domain/BusinessEvent';
import { AppError } from '../../models/other/app-error.model';

@Injectable()
export class NotificationService implements INotificationService {

    private subject: Subject<AppNotification> = new Subject<AppNotification>();

    public getSubject(): Observable<AppNotification> {
        return this.subject.asObservable();
    }

    public showMessage(text: string, title?: string, opts?: any): void {
        const msg: AppNotification = {
            title: title,
            text: text,
            time: new Date(),
            type: AppNotificationTypes.APP_INFO,
            driverId: undefined,
            vehicleId: undefined,
            opts: opts
        };
        this.subject.next(msg);
    }

    public notify(event: BusinessEvent): void {

        if (!event) {
            return;
        }

        const msg: AppNotification = {
            title: event.ED ? event.ED.Label : 'Nowe powiadomienie',
            text: event.ED ? event.ED.Details : '',
            time: event.TS,
            type: event.type || AppNotificationTypes.INFO,
            opts: { autoClose: true },
            driverId: event.DI,
            vehicleId: event.VI || event?.Data?.Id,
        };

        this.subject.next(msg);
    }

    public showSuccess(text: string, title?: string, opts?: any): void {
        const msg = new AppNotification();
        msg.text = text;
        msg.title = title;
        msg.opts = opts;
        msg.type = AppNotificationTypes.APP_INFO;
        this.subject.next(msg);
    }


    public showError(text: string, title?: string, opts?: any): void {
        const msg = new AppNotification();
        msg.text = text;
        msg.title = title;
        msg.opts = opts;
        msg.type = AppNotificationTypes.APP_ERROR;
        this.subject.next(msg);
    }

    public showWarning(text: string, title?: string, opts?: any): void {
        const msg = new AppNotification();
        msg.text = text;
        msg.title = title;
        msg.opts = opts;
        msg.type = AppNotificationTypes.APP_WARN;
        this.subject.next(msg);
    }


    public processAppError(error: AppError) {
        const msg = new AppNotification();
        msg.type = AppNotificationTypes.APP_ERROR;
        msg.data = error;
        this.subject.next(msg);
    }

    constructor() {
    }
}
